import { gql } from '@apollo/client';

export default gql`
  query fetchSalesforceTicketData($bookingReference: String!, $ticketNumbers: [String!]!) {
    fetchSalesforceTicketData(bookingReference: $bookingReference, ticketNumbers: $ticketNumbers) {
      ticketNumber
      isCheckedIn
    }
  }
`;
